import React, { Component } from 'react';
import { Field, reduxForm, change, formValueSelector, FieldArray } from 'redux-form';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import { injectIntl } from 'react-intl';
import cx from 'classnames';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';

import Loader from '../../Common/Loader';
import ImageUploadComponent from '../../../components/Common/ImageUploadComponent';
import CommonImageDisplay from '../CommonImageDisplay/CommonImageDisplay';
import InputFieldComponent from '../../Common/InputFieldComponent/InputFieldComponent';
import SelectFieldComponent from '../../Common/SelectFieldComponent/SelectFieldComponent';

import messages from '../../../locale/messages';
import validate from './validate';
import submit from './submit';
import { updateTempImages } from '../../../actions/siteadmin/TempImages/updateTempImages';
import { formatLocale } from '../../../helpers/formatLocale';
import { api, homepageUploadDir } from '../../../config';
import { demoRestriction } from '../../../actions/demoRestriction';
import { AddContentPlusIcon, DeleteContentPlusIcon } from '../../Common/Assets/SVGIcon/CommonSvgRemainingIcon';

import bt from '../../../components/commonStyle.css';
import s from './SafetySettingsForm.css';


export class SafetySettingsForm extends Component {

	constructor(props) {
		super(props)
		this.state = {
			selectedLanguages: []
		}
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		const { dynamicSafetyGridTitle } = nextProps;
		let filteredLanguages = dynamicSafetyGridTitle?.map((item) => { return item?.language })
		this.setState({ selectedLanguages: filteredLanguages });
	}

	successLogo = async (file, fromServer) => {
		const { change, updateTempImages, demoRestriction } = this.props;
		const isRestrict = await demoRestriction({});
		if (isRestrict) return;
		await change('safetyGridImage4', fromServer?.fileName);
		await updateTempImages('Homepage', 'safetyGridImage4', fromServer?.fileName);
	}

	successBanner = async (file, fromServer) => {
		const { change, updateTempImages, demoRestriction } = this.props;
		const isRestrict = await demoRestriction({});
		if (isRestrict) return;
		await change('safetyGridImage3', fromServer?.fileName);
		await updateTempImages('Homepage', 'safetyGridImage3', fromServer?.fileName);
	}

	successAppStore = async (file, fromServer) => {
		const { change, updateTempImages, demoRestriction } = this.props;
		const isRestrict = await demoRestriction({});
		if (isRestrict) return;
		await change('safetyGridImage2', fromServer?.fileName);
		await updateTempImages('Homepage', 'safetyGridImage2', fromServer?.fileName);
	}

	successPlayStore = async (file, fromServer) => {
		const { change, updateTempImages, demoRestriction } = this.props;
		const isRestrict = await demoRestriction({});
		if (isRestrict) return;
		await change('safetyGridImage1', fromServer?.fileName);
		await updateTempImages('Homepage', 'safetyGridImage1', fromServer?.fileName);
	}


	renderFieldArray = ({ fields, meta: { touched, error }, label }) => {
		const { formatMessage } = this.props.intl;
		const { languageList } = this.props;
		const { selectedLanguages } = this.state;

		return (
			<div className={bt.languageBox}>
				{fields && fields.map((userApp, index) => {
					let fieldLength = fields.length - 1;
					const currentLanguage = fields?.get(index)?.language;
					const availableLanguages = languageList.filter(locale => !selectedLanguages?.includes(locale) || locale === currentLanguage);
					const languagesOption = [{ value: '', label: formatMessage(messages.chooseLanguageLabel) }];
					const languageOptionsFormatted = availableLanguages.map((locale) => {
						return {
							value: locale,
							label: formatLocale(locale)
						};
					});

					languagesOption.push(...languageOptionsFormatted);
					return (
						<div key={`${index}`}>
							<div className="twoColumnGrid">
								<div className='oneColumnGrid'>
									<Field
										name={`${userApp}.language`}
										component={SelectFieldComponent}
										label={formatMessage(messages.language)}
										options={languagesOption}
										inputClass={cx(bt.formControlSelect)}
									/>
									<Field
										name={`${userApp}.value`}
										type="text"
										component={InputFieldComponent}
										label={label}
										inputClass={bt.formControlInput} />
								</div>
								<Field
									name={`${userApp}.description`}
									type="text"
									component={InputFieldComponent}
									componentClass="textarea"
									label={formatMessage(messages.userAppContent)}
									placeholder={formatMessage(messages.userAppContent)}
									inputClass={cx(bt.formTextArea, bt.descTextArea)} />
							</div>
							<div className={cx(bt.languageBtnContainer, 'svgImg', { [bt.languageBtnContainerOne]: (fieldLength > 0) })} >
								{(fields.length <= languageList?.length - 1) && fieldLength == index &&
									<Button className={cx(bt.languageBtn)} onClick={() => fields.length <= languageList?.length - 1 && fields.push({})}>
										<AddContentPlusIcon />
										<span>	{formatMessage(messages.addLanguage)}</span>
									</Button>
								}
								{fieldLength > 0 && <div>
									<Button className={cx(bt.languageBtn, bt.languageDeleteBtn)} onClick={() => fields.remove(index)}>
										<DeleteContentPlusIcon />
										<span>{formatMessage(messages.deleteLanguage)}</span>
									</Button>
								</div>}
							</div>
						</div>
					)
				})
				}
			</div >
		)
	}

	render() {
		const { handleSubmit, safetyGridImage1, safetyGridImage2, safetyGridImage3, loading, submitting, safetyGridImage4 } = this.props;
		const { formatMessage } = this.props.intl;
		const { safetyImageLoader4, safetyImageLoader3, safetyGridLoader1, safetyGridLoader2 } = this.props;
		return (
			<Form className={s.fullWidth} onSubmit={handleSubmit(submit)}>
				<h1 className='siteAdminPrimaryHeading'>{formatMessage(messages.safetySectionSettings)}</h1>
				<Row>
					<Col lg={6} md={6} sm={12} xs={12} className={bt.space4}>
						<div className={cx(s.profileImgSection, s.profileImgWidth)}>
							<label className={bt.commonLabelText} >{formatMessage(messages.backGroundImage)}</label>
							<CommonImageDisplay loader={safetyImageLoader4} imageSrc={ safetyGridImage4 ? api?.apiEndpoint + homepageUploadDir + 'medium_' + safetyGridImage4 : null} />
							<ImageUploadComponent
								className='commonSiteAdminDropzoneSpace'
								subText={formatMessage(messages.maximumUploadSizeLabel)}
								defaultMessage={formatMessage(messages.chooseFile)}
								componentConfig={{
									iconFiletypes: ['.jpg', '.png', '.svg'],
									multiple: false,
									showFiletypeIcon: false,
									postUrl: api.apiEndpoint + '/uploadHomepageImage'
								}}
								success={this.successLogo}
								loaderName={'safetyImageLoader4'}
							/>
						</div>
					</Col>
					<Col lg={6} md={6} sm={12} xs={12} className={bt.space4}>
						<div className={cx(s.profileImgSection, s.profileImgWidth)}>
							<label className={bt.commonLabelText} >{formatMessage(messages.safetyImage3)}</label>
							<CommonImageDisplay loader={safetyImageLoader3} imageSrc={safetyGridImage3 ? api?.apiEndpoint + homepageUploadDir + 'medium_' + safetyGridImage3 : null} />
							<ImageUploadComponent
								className='commonSiteAdminDropzoneSpace'
								subText={formatMessage(messages.maximumUploadSizeLabel)}
								defaultMessage={formatMessage(messages.chooseFile)}
								componentConfig={{
									iconFiletypes: ['.jpg', '.png', '.svg'],
									multiple: false,
									showFiletypeIcon: false,
									postUrl: api.apiEndpoint + '/uploadHomepageImage'
								}}
								success={this.successBanner}
								loaderName={'safetyImageLoader3'}
							/>
						</div>
					</Col>

					<Col lg={6} md={6} sm={12} xs={12} className={bt.space4}>
						<div className={cx(s.profileImgSection, s.profileImgWidth)}>
							<label className={bt.commonLabelText} >{formatMessage(messages.safetyImage1)}</label>
							<CommonImageDisplay loader={safetyGridLoader1} imageSrc={safetyGridImage1 ? api?.apiEndpoint + homepageUploadDir + 'medium_' + safetyGridImage1 : null} />
							<ImageUploadComponent
								className='commonSiteAdminDropzoneSpace'
								subText={formatMessage(messages.maximumUploadSizeLabel)}
								defaultMessage={formatMessage(messages.chooseFile)}
								componentConfig={{
									iconFiletypes: ['.jpg', '.png', '.svg'],
									multiple: false,
									showFiletypeIcon: false,
									postUrl: api.apiEndpoint + '/uploadHomepageImage'
								}}
								success={this.successPlayStore}
								loaderName={'safetyGridLoader1'}
							/>
						</div>
					</Col>
					<Col lg={6} md={6} sm={12} xs={12} className={bt.space4}>
						<div className={cx(s.profileImgSection, s.profileImgWidth)}>
							<label className={bt.commonLabelText} >{formatMessage(messages.safetyImage2)}</label>
							<CommonImageDisplay loader={safetyGridLoader2} imageSrc={safetyGridImage2 ? api.apiEndpoint + homepageUploadDir + 'medium_' + safetyGridImage2 : null} />
							<ImageUploadComponent
								className='commonSiteAdminDropzoneSpace'
								subText={formatMessage(messages.maximumUploadSizeLabel)}
								defaultMessage={formatMessage(messages.chooseFile)}
								componentConfig={{
									iconFiletypes: ['.jpg', '.png', '.svg'],
									multiple: false,
									showFiletypeIcon: false,
									postUrl: api.apiEndpoint + '/uploadHomepageImage'
								}}
								success={this.successAppStore}
								loaderName={'safetyGridLoader2'}
							/>
						</div>
					</Col>
				</Row>
				<div className='twoColumnGrid'>
					<Field
						name="safetyGridLink1"
						type="text"
						component={InputFieldComponent}
						label={formatMessage(messages.playstorelink)}
						placeholder={formatMessage(messages.playstorelink)}
						inputClass={bt.formControlInput} />


					<Field
						name="safetyGridLink2"
						type="text"
						component={InputFieldComponent}
						placeholder={formatMessage(messages.appstorelink)}
						label={formatMessage(messages.appstorelink)}
						inputClass={bt.formControlInput} />
				</div>
				<div className={bt.sectionDividerBorder} />
				<FieldArray
					name="safetyGridTitle1"
					type="text"
					component={this.renderFieldArray}
					rerenderOnEveryChange={true}
					label={formatMessage(messages.userApptitle)} />


				<div className={cx(bt.spaceTop5, bt.paddingTop5, bt.languageBtnDivider, 'singleFlexEndBtn')}>
					<Loader
						type={"button"}
						label={formatMessage(messages.submitButton)}
						show={loading}
						buttonType={'submit'}
						className={cx(bt.btnPrimary, 'loaderButtonFlex')}
						disabled={submitting || loading}
					/>
				</div>
			</Form>
		)
	}
}

SafetySettingsForm = reduxForm({
	form: 'SafetySettingsForm',
	onSubmit: submit,
	validate
})(SafetySettingsForm);

const selector = formValueSelector('SafetySettingsForm');

const mapState = (state) => ({
	safetyGridImage1: selector(state, 'safetyGridImage1'),
	safetyGridImage2: selector(state, 'safetyGridImage2'),
	safetyGridImage3: selector(state, 'safetyGridImage3'),
	safetyGridImage4: selector(state, 'safetyGridImage4'),
	loading: state?.loader?.SafetySettingsForm,
	safetyImageLoader4: state?.loader?.safetyImageLoader4,
	safetyImageLoader3: state?.loader?.safetyImageLoader3,
	safetyGridLoader1: state?.loader?.safetyGridLoader1,
	safetyGridLoader2: state?.loader?.safetyGridLoader2,
	dynamicSafetyGridTitle: selector(state, 'safetyGridTitle1'),
	languageList: state?.runtime?.availableLocales,
});

const mapDispatch = {
	updateTempImages,
	change,
	demoRestriction
}

export default injectIntl(withStyles(bt, s)(connect(mapState, mapDispatch)(SafetySettingsForm)));
